import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import postModel from './postModel.vue';
import { postList, postStatus, postDelete, postIsEdit } from './request';
let expandedRowKeys = [];
const rowSelection = {
  onSelect: (record, selected, selectedRows) => {
    expandedRowKeys = selectedRows;
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    expandedRowKeys = selectedRows;
  }
};
export default {
  components: {
    postModel
  },
  data() {
    return {
      postShow: false,
      form: {
        name: ''
      },
      data: [],
      columns: [{
        slots: {
          title: '岗位名称'
        },
        dataIndex: 'name',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '排序'
        },
        dataIndex: 'sort',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '3',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '是否允许编辑'
        },
        dataIndex: 'isEdit',
        key: '4',
        align: 'center',
        scopedSlots: {
          customRender: 'isEdit'
        }
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 260,
        key: '6'
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      expandedRowKeys,
      rowSelection
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    getDataTable() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      postList(obj).then(res => {
        this.pagination.total = res.totalNum;
        this.data = res.items;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleDel() {
      if (expandedRowKeys.length == 0) {
        this.$message.error(this.$t('请选择') + this.$t('要删除的数据'));
        return false;
      }
      let arr = [];
      expandedRowKeys.map(item => {
        arr.push(item.companyPostId);
      });
      postDelete({
        companyPostId: arr
      }).then(res => {
        expandedRowKeys = [];
        this.$message.success(this.$t('删除成功'));
        this.getDataFun();
      });
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该岗位') + '?', {
        confirmButtonText: this.$t('确定')
      }).then(() => {
        postDelete({
          companyPostId: [val.companyPostId]
        }).then(res => {
          _this.$message.success(this.$t('删除成功'));
          _this.getDataFun();
        });
      });
    },
    checkedFun(val) {
      console.log(val);
      if (!this.isAuth('home.companyPostStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      postStatus({
        companyPostId: val.companyPostId,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('修改成功'));
        this.getDataFun();
      });
    },
    checkedFun2(val) {
      if (!this.isAuth('home.companyPostIsEdit')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      postIsEdit({
        companyPostId: val.companyPostId,
        isEdit: val.isEdit == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('修改成功'));
        this.getDataFun();
      });
    },
    handleAdd(data) {
      this.postShow = true;
      this.$nextTick(() => {
        this.$refs.postForm.init(data);
      });
    }
  }
};